// extracted by mini-css-extract-plugin
export default {"cls1":"SplitMobileFab-FirstOption_cls1__Iujll","cls2":"SplitMobileFab-FirstOption_cls2__LafeO SplitMobileFab-FirstOption_cls1__Iujll"};